import type { RejectPaymentAction } from '../types';

/**
 * Success-toast copy for POST /reject, branched on the server's paymentAction
 * discriminator. Missing / unknown values fall back to the neutral message so
 * older backends stay compatible.
 */
export function rejectSuccessToastCopy(action: RejectPaymentAction | undefined | null): string {
  switch (action) {
    case 'authorization_cancelled':
      return "Order cancelled. Customer's card hold has been released.";
    case 'refund_issued':
      return 'Order cancelled. Refund issued; may take 5–10 business days.';
    case 'no_payment_action':
      return 'Order cancelled.';
    default:
      return 'Order cancelled.';
  }
}
